import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { GknFundamentalCardLink } from '@services';
import { catchError, concatMap, EMPTY, map, Observable, toArray } from 'rxjs';
import { StatusFeed, StatusFeedIncident, StatusFeedMonth } from './home-fundamentals-status-feed.interface';

@Injectable({ providedIn: 'root' })
export class HomeFundamentalsStatusService {
    private http = inject(HttpClient);

    get incidents$(): Observable<GknFundamentalCardLink[]> {
        return this.http.get<StatusFeed>(`${environment.feed.gcStatus.url}/history.json`).pipe(
            concatMap((statusFeed: StatusFeed) => statusFeed.months),
            concatMap((statusFeedMonth: StatusFeedMonth) => statusFeedMonth.incidents),
            map((statusFeedIncident: StatusFeedIncident): GknFundamentalCardLink => {
                const label = this.formatIncidentTitle(statusFeedIncident);
                const url = `${environment.feed.gcStatus.url}/incidents/${statusFeedIncident.code}`;

                const date = new Date(label);

                return {
                    label,
                    url,
                    dataAnalytics: [
                        'status',
                        'incidents',
                        date.getFullYear().toString(),
                        (date.getMonth() + 1).toString(),
                        date.getDate().toString(),
                    ],
                };
            }),
            toArray(),
            catchError((err) => {
                console.error(err);
                return EMPTY;
            }),
        );
    }

    /**
     * Format Incident title
     * @param statusFeedIncident - Status Feed Incident
     * @returns formatted incident title string
     */
    private formatIncidentTitle(statusFeedIncident: StatusFeedIncident): string {
        const date = statusFeedIncident.timestamp.slice(0, statusFeedIncident.timestamp.indexOf(','));
        return date.replace("<var data-var='date'>", '').replace('</var>', `, ${new Date().getFullYear()}`).trim();
    }
}
